import classNames from "classnames";
import { ButtonProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../shared/components/AppButton";
import { PlusIcon } from "../../../../shared/icons/PlusIcon";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import styles from "./styles.module.css";
import { TButton } from "../../../types/buttons";

interface Props extends ButtonProps {
  typeBtn: TButton;
  text?: string;
  isDisabled?: boolean;
  className?: string;
}

export const AddButton = ({
  typeBtn,
  text,
  isDisabled,
  className,
  ...props
}: Props) => {
  const { t } = useTranslation();

  const cls = classNames(
    typeBtn === "icon_btn"
      ? styles["add-button-icon"]
      : styles["add-button-text"],
    {
      [styles.disabled]: isDisabled,
      className,
    }
  );

  if (typeBtn === "icon_btn") {
    return (
      <AppIconButton className={cls} {...props}>
        <PlusIcon />
      </AppIconButton>
    );
  }

  return (
    <AppButton
      buttonType={"text"}
      icon={<PlusIcon />}
      className={cls}
      {...props}
    >
      {text ? text : t("sidebar.add_button")}
    </AppButton>
  );
};
